export const popularDomains = {
  wp_pl: [
    'gmail.com',
    'wp.pl',
    'o2.pl',
    'interia.pl',
    'op.pl',
    'onet.pl',
    'vp.pl',
    'poczta.onet.pl',
    'icloud.com',
    'tlen.pl',
    'onet.eu',
    'poczta.fm',
    'interia.eu',
    'hotmail.com',
    'outlook.com',
    'yahoo.com',
    'gazeta.pl',
    'autograf.pl',
    'onet.com.pl',
    'spoko.pl',
  ],
  kg_ee: [
    'gmail.com',
    'hotmail.com',
    'mail.ee',
    'hot.ee',
    'outlook.com',
    'jardinlilled.ee',
    'yahoo.com',
    'icloud.com',
    'online.ee',
    'live.com',
    'msn.com',
    'windowslive.com',
    'me.com',
    'ut.ee',
  ],
  ld_lt: [
    'gmail.com',
    'yahoo.com',
    'inbox.lt',
    'hotmail.com',
    'sdpanevezys.lt',
    'yahoo.co.uk',
    'outlook.com',
    'icloud.com',
    'yahoo.de',
    'danskebank.lt',
    'girteka.eu',
    'ymail.com',
    'live.com',
    'hotmail.lt',
    'mail.com',
    'googlemail.com',
    'telia.lt',
  ],
  ds_lv: [
    'gmail.com',
    'inbox.lv',
    'yahoo.com',
    'hotmail.com',
    'icloud.com',
    'tvnet.lv',
    'outlook.com',
    'apollo.lv',
    'live.com',
    'yahoo.co.uk',
    'outlook.lv',
    'latnet.lv',
    'rpg.lv',
    'me.com',
    'protonmail.com',
    'seb.se',
    'clarity.cx',
  ],
  el_fi: [
    'gmail.com',
    'hotmail.com',
    'outlook.com',
    'icloud.com',
    'hotmail.fi',
    'kolumbus.fi',
    'elisanet.fi',
    'luukku.com',
    'yahoo.com',
    'windowslive.com',
    'iki.fi',
    'saunalahti.fi',
    'live.com',
    'pp.inet.fi',
    'live.fi',
    'helsinki.fi',
    'welho.com',
    'netti.fi',
    'fimnet.fi',
    'suomi24.fi',
  ],
};
